module.exports.initTodaysRate =
  require('./dist/lib/actions/init-todays-rate').default;
module.exports.fetchHistoricalRates =
  require('./dist/lib/actions/fetch-historical-rates').default;
